class NotificationPreferences {
    constructor(notifyMethods=[], notifyEvents=[], notifyPhone=null, team=null, id=null) {
        this.notifyMethods = notifyMethods
        this.notifyEvents = notifyEvents
        this.notifyPhone = notifyPhone
        this.team = team
        this.id = id
        this.toAPIObject = this.toAPIObject.bind(this)
    }

    static fromDictionary(dict) {
        return new NotificationPreferences(dict.notifyMethods, dict.notifyEvents, dict.notifyPhone, dict.team, dict.id)
    }

    static fromAPIObject(obj) {
        let notifyMethods = []
        let notifyEvents = []
        let notifyPhone = ''
        if (obj.notify_methods && obj.notify_methods.length > 0) {
            notifyMethods = obj.notify_methods.split(",").filter((m)=>m.length>0).map((m)=>Number(m))
        }
        if (obj.notify_events && obj.notify_events.length > 0) {
            notifyEvents = obj.notify_events.split(",").filter((e)=>e.length>0).map((e)=>Number(e))
        }
        if (obj.notify_phone && obj.notify_phone.length > 0) {
            notifyPhone = obj.notify_phone
        }
        let team = obj.team
        let id = obj.id
        return new NotificationPreferences(notifyMethods, notifyEvents, notifyPhone, team, id)
    }

    toAPIObject() {
        return {
            // temp setting this to 1,2
            notify_methods: this.notifyMethods.join(','), //"1,2",//this.notifyMethods.join(','),
            notify_events: this.notifyEvents.join(','),
            notify_phone: this.notifyPhone,
            team: this.team,
            id: this.id
        }
    }
}

export const NOTIFICATION_EVENTS = {
    CONTROLLER_POWER_UP : 1,
    CONTROLLER_POWER_DOWN : 2,
    CONTROLLER_START : 3,
    CONTROLLER_STOP : 4,
    CONTROLLER_SCHEDULED_START : 5,
    CONTROLLER_SCHEDULED_STOP : 6,
    CONTROLLER_STOP_ON_ALARM : 7,
    CONTROLLER_MISSED_HEARTBEAT : 8,
    CONTROLLER_LOW_TANK_ALARM : 9,
    COMMAND_SENT : 10,
    CONTROLLER_FLOW_DID_NOT_STOP : 11
}

export const NOTIFICATION_METHODS = {
    EMAIL : 1,
    PHONE : 2,
    JDO : 3
}

export default NotificationPreferences


// WEBPACK FOOTER //
// ./src/models/NotificationPreferences.js